import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Router } from '@angular/router';
import { Modality } from '../models/task-types.model';
import { AppRoutes } from '../enums/app-routes';
import { AssistantTasksService } from './assistant-tasks.service';
import { UserStateService } from './user-state.service';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class RoutingService {
  private hasConnectedTask = false;
  private isInAcw = false;
  private hasIncomingTask = false;
  private incomingTaskModality: string = null;

  public constructor(
    private readonly tasksService: AssistantTasksService,
    private readonly userStateService: UserStateService,
    private readonly router: Router,
  ) {
    this.tasksService.connectedTask$.pipe(untilDestroyed(this)).subscribe((t) => (this.hasConnectedTask = !!t));
    this.userStateService.isInAcw$.pipe(untilDestroyed(this)).subscribe((v) => (this.isInAcw = v));
    this.tasksService.incomingTask$.pipe(untilDestroyed(this)).subscribe((t) => {
      this.hasIncomingTask = !!t;
      this.incomingTaskModality = t?.modality ?? null;
    });
  }

  public goToDefaultPage(): void {
    let route = AppRoutes.home;
    if (this.hasConnectedTask || this.isInAcw) {
      route = AppRoutes.call;
    }

    // Pre-1.134 this went to AppRoutes.sessionInvitations to show the invitation screen. That component and its
    // route were removed, so navigating there now falls through to the '**' wildcard and redirects to login.
    // The incoming task is rendered by the shell's overlay on any child route, so home is the equivalent target.
    const isNonCallSession = this.incomingTaskModality !== Modality.Audio;
    if (this.hasIncomingTask && isNonCallSession) {
      route = AppRoutes.home;
    }

    this.router.navigate([route]);
  }

  public navigate(route: string): void {
    this.router.navigate([route]);
  }
}
